<script setup lang="ts" name="DataTableActions">
import BaseButton from '~/components/BaseButton.vue';

import type { IDataTableAction } from '~/types';

defineProps<{
  actions: IDataTableAction[];
}>();
</script>

<template>
  <div class="flex h-full items-center justify-center" @click.stop>
    <BaseButton
      v-for="action in actions"
      :key="action.key"
      :to="action.to"
      :variant="action.variant ?? 'btn-primary'"
      :icon="action.icon"
      :data-testid="action.dataTestId"
      :tooltip-description="action.tooltipDescription"
      :disabled="action.disabled"
      @click="action.handler"
    />
  </div>
</template>
